import { render, staticRenderFns } from "./DirectorDividendsLatest.vue?vue&type=template&id=c92c7bc6"
import script from "./DirectorDividendsLatest.vue?vue&type=script&lang=js"
export * from "./DirectorDividendsLatest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports